const i18n = {
    'pt-BR': {
        lang: 'pt-BR',
        currency: 'BRL',
    },
};
export default i18n['pt-BR'];
